import { IMapState } from '../../types';

export function selectIsWebGlRendering(state: IMapState): boolean {
  return state.map.infrastructure.config.webGl;
}
